export const payerRecords = [
  {
    id: 'payer-1',
    name: '天津北栈智能设备有限公司',
    accounts: [
      {
        accountNo: '120001450000771122',
        bankName: '工商银行天津海河支行',
        bankCode: '102110000021',
        reverse3: true
      },
      {
        accountNo: '120001450000884433',
        bankName: '中信银行天津滨海支行',
        bankCode: '302110000017'
      }
    ]
  },
  {
    id: 'payer-2',
    name: '南京阔野流程服务有限公司',
    accounts: [
      {
        accountNo: '320101660000235577',
        bankName: '招商银行南京河西支行',
        bankCode: '308301000105',
        reverse3: true
      },
      {
        accountNo: '320101660000662211',
        bankName: '江苏银行南京建邺支行',
        bankCode: '313301000026'
      }
    ]
  },
  {
    id: 'payer-3',
    name: '武汉岚屿空间设计有限公司',
    accounts: [
      {
        accountNo: '420103990000112277',
        bankName: '建设银行武汉光谷支行',
        bankCode: '105521000168',
        reverse3: true
      }
    ]
  },
  {
    id: 'payer-4',
    name: '西安远垣数据系统有限公司',
    accounts: [
      {
        accountNo: '610104880000332244',
        bankName: '中国银行西安高新支行',
        bankCode: '104791000032'
      }
    ]
  },
  {
    id: 'payer-5',
    name: '青岛潮轨冷链物流有限公司',
    accounts: [
      {
        accountNo: '370202770000556688',
        bankName: '农业银行青岛崂山支行',
        bankCode: '103452000021',
        reverse3: true
      },
      {
        accountNo: '370202770000991144',
        bankName: '邮储银行青岛市南支行',
        bankCode: '403452000010'
      }
    ]
  },
  {
    id: 'payer-6',
    name: '厦门泊舟数字传媒有限公司',
    accounts: [
      {
        accountNo: '350203550000128899',
        bankName: '平安银行厦门软件园支行',
        bankCode: '307393000022',
        reverse3: true
      }
    ]
  },
  {
    id: 'payer-7',
    name: '重庆杉岸工业采购有限公司',
    accounts: []
  }
]

export const bankBranchRecords = [
  {
    id: 'branch-001',
    bankName: '工商银行',
    branchName: '工商银行天津海河支行',
    bankCode: '102110000021'
  },
  {
    id: 'branch-002',
    bankName: '中信银行',
    branchName: '中信银行天津滨海支行',
    bankCode: '302110000017'
  },
  {
    id: 'branch-003',
    bankName: '招商银行',
    branchName: '招商银行南京河西支行',
    bankCode: '308301000105'
  },
  {
    id: 'branch-004',
    bankName: '江苏银行',
    branchName: '江苏银行南京建邺支行',
    bankCode: '313301000026'
  },
  {
    id: 'branch-005',
    bankName: '建设银行',
    branchName: '建设银行武汉光谷支行',
    bankCode: '105521000168'
  },
  {
    id: 'branch-006',
    bankName: '中国银行',
    branchName: '中国银行西安高新支行',
    bankCode: '104791000032'
  },
  {
    id: 'branch-007',
    bankName: '农业银行',
    branchName: '农业银行青岛崂山支行',
    bankCode: '103452000021'
  },
  {
    id: 'branch-008',
    bankName: '邮储银行',
    branchName: '邮储银行青岛市南支行',
    bankCode: '403452000010'
  },
  {
    id: 'branch-009',
    bankName: '平安银行',
    branchName: '平安银行厦门软件园支行',
    bankCode: '307393000022'
  },
  {
    id: 'branch-010',
    bankName: '浦发银行',
    branchName: '浦发银行苏州园区支行',
    bankCode: '310305000014'
  },
  {
    id: 'branch-011',
    bankName: '民生银行',
    branchName: '民生银行合肥政务区支行',
    bankCode: '305361000019'
  },
  {
    id: 'branch-012',
    bankName: '光大银行',
    branchName: '光大银行长沙岳麓支行',
    bankCode: '303551000023'
  },
  {
    id: 'branch-013',
    bankName: '广发银行',
    branchName: '广发银行佛山南海支行',
    bankCode: '306581000021'
  },
  {
    id: 'branch-014',
    bankName: '华夏银行',
    branchName: '华夏银行郑州郑东支行',
    bankCode: '304491000015'
  },
  {
    id: 'branch-015',
    bankName: '宁波银行',
    branchName: '宁波银行无锡新吴支行',
    bankCode: '316302000018'
  },
  {
    id: 'branch-016',
    bankName: '交通银行',
    branchName: '交通银行福州台江支行',
    bankCode: '301391000012'
  },
  {
    id: 'branch-017',
    bankName: '浙商银行',
    branchName: '浙商银行宁波鄞州支行',
    bankCode: '316332000024'
  },
  {
    id: 'branch-018',
    bankName: '北京银行',
    branchName: '北京银行成都锦江支行',
    bankCode: '313651000011'
  },
  {
    id: 'branch-019',
    bankName: '上海银行',
    branchName: '上海银行南昌红谷滩支行',
    bankCode: '313421000013'
  },
  {
    id: 'branch-020',
    bankName: '兴业银行',
    branchName: '兴业银行泉州丰泽支行',
    bankCode: '309391000027'
  }
]

export const recipientRosterRecords = [
  {
    id: 'payee-001',
    payeeType: 'public',
    payeeName: '苏州衡启精密制造有限公司',
    payeeAccount: '310556778899001122',
    bankCode: '310305000014',
    payerIds: ['payer-1', 'payer-2']
  },
  {
    id: 'payee-002',
    payeeType: 'public',
    payeeName: '合肥叙白软件外包有限公司',
    payeeAccount: '621226880011223355',
    bankCode: '305361000019',
    payerIds: ['payer-2', 'payer-3']
  },
  {
    id: 'payee-003',
    payeeType: 'public',
    payeeName: '长沙临禾文化传播有限公司',
    payeeAccount: '622575443322110099',
    bankCode: '303551000023',
    payerIds: ['payer-3', 'payer-6']
  },
  {
    id: 'payee-004',
    payeeType: 'public',
    payeeName: '佛山拓井建材贸易有限公司',
    payeeAccount: '622568770011223344',
    bankCode: '306581000021',
    payerIds: ['payer-4', 'payer-5']
  },
  {
    id: 'payee-005',
    payeeType: 'public',
    payeeName: '郑州松驿会展服务有限公司',
    payeeAccount: '622630998877665544',
    bankCode: '304491000015',
    payerIds: ['payer-1', 'payer-4']
  },
  {
    id: 'payee-006',
    payeeType: 'private',
    payeeName: '许嘉宁',
    payeeAccount: '6228481029384756012',
    bankCode: '316302000018',
    payerIds: ['payer-2', 'payer-5']
  },
  {
    id: 'payee-007',
    payeeType: 'private',
    payeeName: '韩书瑶',
    payeeAccount: '6217004567891230456',
    bankCode: '301391000012',
    payerIds: ['payer-3']
  },
  {
    id: 'payee-008',
    payeeType: 'private',
    payeeName: '卢景川',
    payeeAccount: '6230580001122334455',
    bankCode: '316332000024',
    payerIds: ['payer-5', 'payer-6']
  }
]

export const quickDocumentRecords = [
  {
    id: 'doc-001',
    documentNo: 'FK202604070101',
    documentTitle: '产线夹具采购款',
    payerId: 'payer-1',
    payerAccountNo: '120001450000771122',
    payeeType: 'yes',
    payeeName: '苏州衡启精密制造有限公司',
    payeeAccount: '310556778899001122',
    bankCode: '310305000014',
    amount: '41320.00',
    purpose: '货款'
  },
  {
    id: 'doc-002',
    documentNo: 'FK202604070102',
    documentTitle: '实施外包服务费',
    payerId: 'payer-2',
    payerAccountNo: '320101660000235577',
    payeeType: 'yes',
    payeeName: '合肥叙白软件外包有限公司',
    payeeAccount: '621226880011223355',
    bankCode: '305361000019',
    amount: '18800.00',
    purpose: '服务费'
  },
  {
    id: 'doc-003',
    documentNo: 'FK202604070103',
    documentTitle: '品牌物料设计费',
    payerId: 'payer-6',
    payerAccountNo: '350203550000128899',
    payeeType: 'yes',
    payeeName: '长沙临禾文化传播有限公司',
    payeeAccount: '622575443322110099',
    bankCode: '303551000023',
    amount: '9600.00',
    purpose: '咨询费'
  },
  {
    id: 'doc-004',
    documentNo: 'FK202604070104',
    documentTitle: '园区装修材料结算',
    payerId: 'payer-5',
    payerAccountNo: '370202770000556688',
    payeeType: 'yes',
    payeeName: '佛山拓井建材贸易有限公司',
    payeeAccount: '622568770011223344',
    bankCode: '306581000021',
    amount: '52760.40',
    purpose: '材料费'
  },
  {
    id: 'doc-005',
    documentNo: 'FK202604070105',
    documentTitle: '展会场地预付款',
    payerId: 'payer-4',
    payerAccountNo: '610104880000332244',
    payeeType: 'yes',
    payeeName: '郑州松驿会展服务有限公司',
    payeeAccount: '622630998877665544',
    bankCode: '304491000015',
    amount: '24000.00',
    purpose: '保证金'
  },
  {
    id: 'doc-006',
    documentNo: 'FK202604070106',
    documentTitle: '员工借款报销冲销',
    payerId: 'payer-2',
    payerAccountNo: '320101660000662211',
    payeeType: 'no',
    payeeName: '许嘉宁',
    payeeAccount: '6228481029384756012',
    bankCode: '316302000018',
    amount: '3650.00',
    purpose: '还款'
  },
  {
    id: 'doc-007',
    documentNo: 'FK202604070107',
    documentTitle: '设计团队补贴发放',
    payerId: 'payer-3',
    payerAccountNo: '420103990000112277',
    payeeType: 'no',
    payeeName: '韩书瑶',
    payeeAccount: '6217004567891230456',
    bankCode: '301391000012',
    amount: '2800.00',
    purpose: '生活费'
  },
  {
    id: 'doc-008',
    documentNo: 'FK202604070108',
    documentTitle: '摄影项目劳务费',
    payerId: 'payer-6',
    payerAccountNo: '350203550000128899',
    payeeType: 'no',
    payeeName: '卢景川',
    payeeAccount: '6230580001122334455',
    bankCode: '316332000024',
    amount: '7200.00',
    purpose: '劳务费'
  },
  {
    id: 'doc-009',
    documentNo: 'FK202604070109',
    documentTitle: '设备采购退款',
    payerId: 'payer-1',
    payerAccountNo: '120001450000884433',
    payeeType: 'yes',
    payeeName: '苏州衡启精密制造有限公司',
    payeeAccount: '310556778899001122',
    bankCode: '310305000014',
    amount: '8600.00',
    purpose: '退款'
  },
  {
    id: 'doc-010',
    documentNo: 'FK202604070110',
    documentTitle: '项目备用金申请',
    payerId: 'payer-5',
    payerAccountNo: '370202770000991144',
    payeeType: 'yes',
    payeeName: '郑州松驿会展服务有限公司',
    payeeAccount: '622630998877665544',
    bankCode: '304491000015',
    amount: '12000.00',
    purpose: '备用金'
  },
  {
    id: 'doc-011',
    documentNo: 'FK202604070111',
    documentTitle: '渠道工资发放样例',
    payerId: 'payer-2',
    payerAccountNo: '320101660000235577',
    payeeType: 'no',
    payeeName: '许嘉宁',
    payeeAccount: '6228481029384756012',
    bankCode: '316302000018',
    amount: '9300.00',
    purpose: '工资'
  },
  {
    id: 'doc-012',
    documentNo: 'FK202604070112',
    documentTitle: '厂房月度租金代付',
    payerId: 'payer-4',
    payerAccountNo: '610104880000332244',
    payeeType: 'no',
    payeeName: '卢景川',
    payeeAccount: '6230580001122334455',
    bankCode: '316332000024',
    amount: '5400.00',
    purpose: '房租'
  }
]